"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseValidationsStr = void 0;

var _validators = require("@sword-health/vuelidate/lib/validators");

var _generalValidators = require("./scripts/general-validators.js");

var _dateValidators = require("./scripts/date-validators.js");

var _fileValidators = require("./scripts/file-validators");

var _regex = _interopRequireDefault(require("./scripts/regex.js"));

var _defaults = require("./scripts/defaults.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/*
 * Validations map for string based validations
 */
var parseValidationsStr = function parseValidationsStr(vObj) {
  if (!Object.keys(vObj).length) {
    return {};
  }

  if (vObj.hasOwnProperty('pack')) {
    var packName = vObj.pack;
    Object.assign(vObj, _defaults.vDefaultPacks[packName]);
    delete vObj.pack;
  }

  var validationObj = {};
  Object.keys(vObj).forEach(function (vKey) {
    var params = [].concat(vObj[vKey]);
    var validatorsToApply = validationsMap[vKey];
    var readyValidators = {};
    Object.keys(validatorsToApply).forEach(function (valKey) {
      readyValidators[valKey] = validatorsToApply[valKey].apply(validatorsToApply, _toConsumableArray(params));
    });
    Object.assign(validationObj, readyValidators);
  });
  return validationObj;
};

exports.parseValidationsStr = parseValidationsStr;
var validationsMap = {
  required: {
    required: function required() {
      return function (value) {
        return (0, _validators.required)(value) && _regex["default"].rejectEmpty.test(value);
      };
    }
  },
  atLeastOne: {
    atLeastOne: function atLeastOne() {
      return _validators.required;
    }
  },
  minL: {
    minLength: function minLength(min) {
      return (0, _validators.minLength)(min);
    }
  },
  maxL: {
    maxLength: function maxLength(max) {
      return (0, _validators.maxLength)(max);
    }
  },
  maxV: {
    maxValue: function maxValue(max) {
      return (0, _validators.maxValue)(max);
    }
  },
  minV: {
    minValue: function minValue(min) {
      return (0, _validators.minValue)(min);
    }
  },
  minLimit: {
    minLimit: function minLimit(min) {
      return (0, _validators.minValue)(min);
    }
  },
  maxLimit: {
    maxLimit: function maxLimit(max) {
      return (0, _validators.maxValue)(max);
    }
  },
  sameAsPassword: {
    sameAsPassword: function sameAsPassword(fieldName) {
      return (0, _validators.sameAs)(fieldName);
    }
  },
  maxLengthMinusOffset: {
    maxLength: function maxLength(max, offset) {
      return (0, _generalValidators.maxLengthMinusOffset)(max, offset);
    }
  },
  minLengthMinusOffset: {
    minLength: function minLength(min, offset) {
      return (0, _generalValidators.minLengthMinusOffset)(min, offset);
    }
  },
  maxLengthOfDecimalNumber: {
    maxLength: function maxLength(integerMax, fractionalMax) {
      return (0, _generalValidators.maxLengthOfDecimalNumber)(integerMax, fractionalMax);
    }
  },
  email: {
    emailFormat: function emailFormat() {
      return function (email) {
        return _regex["default"].email.global.test(email);
      };
    }
  },
  url: {
    validUrl: function validUrl() {
      return function (url) {
        return _regex["default"].url.general.test(url);
      };
    }
  },
  username: {
    usernameFormat: function usernameFormat() {
      return function (username) {
        return _regex["default"].username.global.test(username);
      };
    }
  },
  prefixAndPhoneReq: {
    prefixAndPhoneRequired: function prefixAndPhoneRequired() {
      return function (phone) {
        return _regex["default"].phone.complete.test(phone);
      };
    }
  },
  internationalPhoneFormat: {
    internationalPhoneFormat: function internationalPhoneFormat() {
      return function (phone) {
        return _regex["default"].phone.international.test(phone);
      };
    }
  },
  prefixFormat: {
    // Only checks for Prefix
    prefix: function prefix() {
      return function (phone) {
        if (!phone) {
          return true;
        }

        var prefix = phone.split("//")[0].trim();

        if (!prefix) {
          return false;
        }

        return _regex["default"].phone.prefix.test(prefix);
      };
    }
  },
  phoneNumberFormat: {
    // Only checks for Phone
    phoneNumber: function phoneNumber() {
      return function (phone) {
        if (!phone) {
          return true;
        }

        var number = phone.split("//")[1].trim();

        if (!number) {
          return false;
        }

        return _regex["default"].phone.number.test(number);
      };
    }
  },
  validChars: {
    invalidCharacter: function invalidCharacter(regex) {
      return function (value) {
        return (0, _generalValidators.regexFit)(value, regex);
      };
    }
  },
  phoneFormat: {
    // Complete phone
    phoneFormat: function phoneFormat() {
      return function (phone) {
        if (!phone) {
          return true;
        }

        var phoneParts = phone.match(_regex["default"].phone.complete);

        if (!phoneParts) {
          return false;
        }

        var prefix = phoneParts[1];
        var number = phoneParts[3];
        return _regex["default"].phone.prefix.test(prefix) && _regex["default"].phone.number.test(number);
      };
    }
  },
  validDay: {
    validDay: function validDay() {
      return (0, _dateValidators.validDay)();
    }
  },
  validMonth: {
    validMonth: function validMonth() {
      return _dateValidators.validMonth;
    }
  },
  validYear: {
    validYear: function validYear(min, max) {
      return (0, _dateValidators.validYear)(min, max);
    }
  },
  isNotFuture: {
    isNotFuture: function isNotFuture() {
      return _dateValidators.isNotFuture;
    }
  },
  isFuture: {
    isFuture: function isFuture() {
      return _dateValidators.isFuture;
    }
  },
  maxFileSize: {
    maxFileSize: function maxFileSize(max) {
      return (0, _fileValidators.maxFileSize)(max);
    }
  },
  validFileTypes: {
    validFileTypes: function validFileTypes(types) {
      return (0, _fileValidators.validFileTypes)(types);
    }
  },
  maxChecked: {
    maxLimit: function maxLimit(max) {
      return (0, _validators.maxLength)(max);
    }
  }
};